export const defaultKeyWindowName = 'all';
